import { IconButton } from '@material-ui/core';
import { getFromLS } from '@orientaction/utils';
import { PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { CONSULTANT_ROLE_ID, getServiceBadgeStyle } from '../../shared/constants';
import { useStyles } from '../styles';
import {
  getConsultantDisplayForService,
  getConsultantIdForService,
  getServiceName,
  getUserPrestations,
} from '../utils';

interface PrestationsTabProps {
  user: any;
  onDeletePrestation?: (service: { id: number; name: string }) => void;
  onAddPrestation?: () => void;
  onEditPrestation?: (service: { id: number; name: string }) => void;
}

const PrestationsTab: FC<PrestationsTabProps> = ({
  user,
  onDeletePrestation,
  onAddPrestation,
  onEditPrestation,
}) => {
  const classes = useStyles();
  const prestations = getUserPrestations(user);
  const connectedUser = JSON.parse(getFromLS('userInfos') || '{}');
  const isConsultant = Number(connectedUser?.company_user_role?.id) === CONSULTANT_ROLE_ID;
  const connectedUserId = Number(connectedUser?.id);

  const canManagePrestation = (serviceId: number) => {
    if (!isConsultant) {
      return true;
    }
    const ownerId = getConsultantIdForService(user, serviceId);
    return ownerId != null && ownerId === connectedUserId;
  };

  return (
    <>
      <div className={classes.tableWrap}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th className={classes.thLeft}>Prestation</th>
              <th className={classes.thLeft}>Administrateur de rattachement</th>
              <th className={classes.thRight}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {prestations.length === 0 ? (
              <tr>
                <td colSpan={3} className={classes.emptyCell}>
                  Aucune prestation rattachée
                </td>
              </tr>
            ) : (
              prestations.map(service => {
                const colors = getServiceBadgeStyle(Number(service.id));
                const consultantName = getConsultantDisplayForService(user, service.id) || '—';
                return (
                  <tr key={service.id}>
                    <td>
                      <span
                        className={classes.prestationBadge}
                        style={{ backgroundColor: colors.background, color: colors.color }}>
                        {getServiceName(service)}
                      </span>
                    </td>
                    <td>{consultantName}</td>
                    <td className={classes.actionsCell}>
                      {canManagePrestation(Number(service.id)) && (
                        <>
                          <IconButton
                            className={classes.iconBtn}
                            aria-label="Éditer"
                            onClick={() =>
                              onEditPrestation?.({
                                id: Number(service.id),
                                name: getServiceName(service),
                              })
                            }>
                            <PencilSimpleIcon size={18} />
                          </IconButton>
                          <IconButton
                            className={classes.iconBtn}
                            aria-label="Supprimer la prestation"
                            onClick={() =>
                              onDeletePrestation?.({
                                id: Number(service.id),
                                name: getServiceName(service),
                              })
                            }>
                            <TrashIcon size={18} />
                          </IconButton>
                        </>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        className={classes.addPrestationBtn}
        onClick={onAddPrestation}>
        + <span>Ajouter une prestation</span>
      </button>
    </>
  );
};

export default PrestationsTab;
